import { isUndefined, isEqual } from 'lodash'

export default class SimilarListingFiltersModel {
  uriWithoutOffset = ''
  filterQueryStringVar = ''
  activeFilters = []
  isTopLevelCategory = false

  constructor (uriWithoutOffset, filterQueryStringVar, activeFilters, isTopLevelCategory) {
    this.uriWithoutOffset = uriWithoutOffset
    this.filterQueryStringVar = filterQueryStringVar
    this.activeFilters = activeFilters
    this.isTopLevelCategory = isTopLevelCategory
  }

  static isTextRangeGroup (group) {
    if (isUndefined(group.similars.chunks) && group.similars.length > 0) {
      return false
    }
    return (group.similarDisplayType === 'text-range-per-count' || group.similarDisplayType === 'text-range-per-value') && group.similars.chunks.length > 0
  }

  static inactivateTextRageFilter (entry, activeFilters) {
    const chunkValueIds = entry.chunkValueIds

    activeFilters = activeFilters.filter(e => {
      return !chunkValueIds.includes(e)
    })

    return activeFilters
  }

  static inactivateBaseFilter (entry, activeFilters) {
    const similarId = entry.similarId

    activeFilters = activeFilters.filter(e => {
      return e !== similarId
    })

    return activeFilters
  }

  removeQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = ''

    if (this.activeFilters === null) {
      return ''
    }

    if (SimilarListingFiltersModel.isTextRangeGroup(group)) {
      activeFilters = SimilarListingFiltersModel.inactivateTextRageFilter(entry, this.activeFilters)
    } else {
      activeFilters = SimilarListingFiltersModel.inactivateBaseFilter(entry, this.activeFilters)
    }

    for (const filter of activeFilters) {
      if (this.activeFilters.length - 1 !== this.activeFilters.indexOf(filter)) {
        str += this.filterQueryStringVar + '[]=' + filter + '&'
      } else {
        str += this.filterQueryStringVar + '[]=' + filter
      }
    }

    return (str !== '') ? `?${str}` : '/' + this.uriWithoutOffset
  }

  addQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = ''

    if (activeFilters === null) {
      return ''
    }

    for (const filter of activeFilters) {
      if (activeFilters.length - 1 !== activeFilters.indexOf(filter)) {
        str += this.filterQueryStringVar + '[]=' + filter + '&'
      } else {
        str += this.filterQueryStringVar + '[]=' + filter
      }
    }

    return `?${str}`
  }

  createLinkQueryStringForRangeGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    let stringWithAllIdsIncluded = ''
    for (const similarId of entry.chunkValueIds) {
      stringWithAllIdsIncluded += '&' + this.filterQueryStringVar + '[]=' + similarId
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (!isEqual(activeFilters.sort(), entry.chunkValueIds.sort())) {
        return finalString
      }

      if (this.isTopLevelCategory) {
        return finalString + '/1'
      }

      return '/' + this.uriWithoutOffset
    } else {
      if (this.activeFilters === null) {
        return this.addQueryString(group, entry, activeFilters) + '?' + stringWithAllIdsIncluded
      }
      return this.addQueryString(group, entry, activeFilters) + stringWithAllIdsIncluded
    }
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        finalString = '/' + this.uriWithoutOffset
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + entry.similarId

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + entry.similarId
      }
    }

    return finalString
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    if (SimilarListingFiltersModel.isTextRangeGroup(group)) {
      return this.createLinkQueryStringForRangeGroup(group, entry, isFilterUsed)
    } else {
      return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
    }
  }
}
